{
  "title": "Reincarnate",
  "source": "Player's Handbook",
  "levelAndSchool": "5th-level transmutation",
  "level": 5,
  "castingTime": "1 hour",
  "range": "Touch",
  "components": "V, S, M (rare oils and unguents worth at least 1,000 gp, which the spell consumes)",
  "duration": "Instantaneous",
  "description": [
    "You touch a dead humanoid or a piece of a dead humanoid. Provided that the creature has been dead no longer than 10 days, the spell forms a new adult body for it and then calls the soul to enter that body. If the target’s soul isn’t free or willing to do so, the spell fails.",
    "The magic fashions a new body for the creature to inhabit, which likely causes the creature’s race to change. The DM rolls a d100 and consults the following table to determine what form the creature takes when restored to life, or the DM chooses a form.",
    "Reincarnation Table",
    "d100",
    "Race",
    "01-04",
    "Dragonborn",
    "05-13",
    "Dwarf, hill",
    "14-21",
    "Dwarf, mountain",
    "22-25",
    "Elf, dark",
    "26-34",
    "Elf, high",
    "35-42",
    "Elf, wood",
    "43-46",
    "Gnome, forest",
    "47-52",
    "Gnome, rock",
    "53-56",
    "Half-elf",
    "57-60",
    "Half-orc",
    "61-68",
    "Halfling, lightfoot",
    "69-76",
    "Halfling, stout",
    "77-96",
    "Human",
    "97-00",
    "Tiefling",
    "The reincarnated creature recalls its former life and experiences. It retains the capabilities it had in its original form, except it exchanges its original race for the new one and changes its racial traits accordingly."
  ],
  "spellLists": ["druid"]
}
